import React, { useEffect, useRef, useState } from "react";

let mermaidPromise;
const loadMermaid = () => {
  if (!mermaidPromise) {
    mermaidPromise = import("mermaid").then((m) => {
      m.default.initialize({
        startOnLoad: false,
        theme: "base",
        securityLevel: "loose",
        themeVariables: {
          primaryColor: "#eaf1fb", primaryTextColor: "#0f2557", primaryBorderColor: "#29abe2",
          lineColor: "#5c6b84", secondaryColor: "#fdf3d9", tertiaryColor: "#f2f6fb",
          fontFamily: "Poppins, sans-serif", fontSize: "13px",
        },
      });
      return m.default;
    });
  }
  return mermaidPromise;
};

export const Mermaid = ({ chart, id = "d" }) => {
  const ref = useRef(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    let active = true;
    if (!chart) return;
    setErr("");
    loadMermaid().then(async (mermaid) => {
      try {
        const { svg } = await mermaid.render(`mmd-${id}-${Math.random().toString(36).slice(2)}`, chart);
        if (active && ref.current) ref.current.innerHTML = svg;
      } catch (e) {
        if (active) setErr(String(e?.message || e));
      }
    });
    return () => { active = false; };
  }, [chart, id]);
  if (err) return <pre className="text-xs text-red-500 whitespace-pre-wrap p-3 bg-red-500/5 rounded">{err}</pre>;
  return <div ref={ref} className="mermaid-host overflow-auto [&_svg]:max-w-full [&_svg]:h-auto" data-testid={`mermaid-${id}`} />;
};

export default Mermaid;
